import GeneralInfo from './GeneralInfo';
import Summary from './Summary';

export {
  GeneralInfo,
  Summary,
}



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/Detail/index.js